import { Component, OnInit, OnDestroy, Renderer2, NgZone } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { map, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { RequestHelpersService } from './shared/services/request-helpers.service';
import {
  Route,
  useNavigationStore as navStore,
} from './store/navigation.store';
import { LocalStorageKeys } from './constants/storageKeys';

import * as fromRoot from './store/app.reducer';
import * as AuthActions from './auth/store/auth.actions';
// import * as MessageTemplateActions from './store/message-templates/message-templates.actions';
// import * as CampaignsActions from './store/campaigns/campaigns.actions';
// import * as LeadListActions from './store/lead-list/lead-list.actions';
import * as UserActions from './store/user/user.actions';
import { AnalyticsManagerService } from './shared/services/analytics-manager.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [Location],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  isAuthenticated = false;
  setCurrentPage = navStore.getState().setCurrentPage;
  activeRoute = null;
  title: string = 'pipa';
  loadingDataImg: boolean = false;
  isPhoneVerified: boolean = false;

  private userAuthSub$: Subscription;

  constructor(
    private store: Store<fromRoot.AppState>,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private requestHelpersService: RequestHelpersService,
    private renderer: Renderer2,
    private zone: NgZone
  ) {
    router.events.subscribe((val) => {
      const basePath = location
        .path()
        .split('/')
        .filter((chunk) => chunk)[0]
        ?.split('?')[0];
      let chunks = location
        .path()
        .split('/')
        .filter((chunk) => chunk);
      let titleArray = [];
      chunks.forEach((chunk) => {
        let title = chunk
          .split('-')
          .map((word) => word[0].toUpperCase() + word.substring(1))
          .join(' ');

        if (title.includes('?')) {
          title = title.split('?')[0];
        }

        titleArray.push(title);
      });

      this.titleService.setTitle(this.title + ' | ' + titleArray.join(' | '));

      this.setCurrentPage(basePath as Route);
      this.activeRoute = navStore.getState().currentPage;

      // Inform the MFE shell of the host's current route so the active-nav
      // highlight stays in sync without the MFE patching history.
      // detail.path matches window.location.pathname value/format (e.g. '/leads/create-lead-lists').
      // Gate to NavigationEnd so the MFE only receives a stable, committed path —
      // early router events carry a stale or intermediate path.
      if (val instanceof NavigationEnd) {
        window.dispatchEvent(
          new CustomEvent('mfe:route-change', {
            detail: { path: location.path() },
            bubbles: true,
            composed: true,
          })
        );
      }
    });
    this.userAuthSub$ = this.store
      .select('auth')
      .pipe(map((authState) => authState.user))
      .subscribe((user) => {
        this.isAuthenticated = !!user;
      });

    /** START : Code to Track Page View using gtag.js */
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const userData: {
          _token: string;
        } = JSON.parse(localStorage.getItem(LocalStorageKeys.CLIENT_JWT));

        const isTokenExpired = this.requestHelpersService.isJwtExpired();

        if (!userData && this.activeRoute !== 'auth') {
          router.navigate(['/auth'])
          this.store.dispatch(AuthActions.logOut());
        } else if (userData && isTokenExpired && this.activeRoute !== 'auth') {
          router.navigate(['/auth'])
          this.store.dispatch(AuthActions.logOut());
        } else if (userData && !isTokenExpired) {
          this.store.dispatch(UserActions.fetchUserDetailsStart());
        }

        AnalyticsManagerService.recordPageView(event.urlAfterRedirects);
      });
    /** END : Code to Track Page View  using gtag.js */
  }

  ngOnInit() {
    this.store.dispatch(AuthActions.autoLogin());

    // Listen for MFE navigation events
    this.renderer.listen('window', 'mfe:navigate', (event: CustomEvent) => {
      const { to, replace } = event.detail || {};

      // Run inside Angular's zone so Router navigation triggers change detection
      this.zone.run(() => {
        if (replace) {
          this.router.navigateByUrl(to, { replaceUrl: true });
        } else {
          this.router.navigateByUrl(to);
        }
      });
    });

    // Listen for MFE logout events
    this.renderer.listen('window', 'mfe:logout', () => {
      this.zone.run(() => {
        this.store.dispatch(AuthActions.logOut());
        this.router.navigate(['/auth']);
      });
    });
  }

  ngOnDestroy() {
    // this.userAuthSub$.unsubscribe();
  }
}
